import { FC, useMemo } from 'react';

import { styled, useTheme } from '@mui/material/styles';

import type { Theme } from '@mui/material';
import type { SxProps } from '@mui/system';

interface LogoProps {
  sx?: SxProps<Theme>;
  alwaysWhite?: boolean;
}

const LogoRoot = styled('svg')``;

const Logo: FC<LogoProps> = (props) => {
  const { alwaysWhite, ...other } = props;

  const theme = useTheme();

  const fill = useMemo(
    () => (theme.palette.mode === 'light' && !alwaysWhite ? 'black' : 'white'),
    [theme.palette.mode, alwaysWhite]
  );

  return (
    <LogoRoot
      height="32"
      version="1.1"
      viewBox="0 0 156 52"
      width="156"

      {...other}
    >
      <title>Zensum</title>

      <svg
        width="156"
        height="32"
        viewBox="0 0 156 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4509 11.5005L4.67555 22.3286C2.90255 24.1102 4.1167 27.1261 6.59058 27.2202L6.70972 27.2231H29.6765V31.0493H6.70972L6.43238 31.0444C0.659516 30.8254 -2.17373 23.7857 1.96363 19.6284L12.739 8.80127L15.4509 11.5005Z"
          fill="#1C7CBA"
        />
        <path
          d="M25.8242 0.955811C31.597 1.17499 34.4303 8.2146 30.293 12.3718L19.5176 23.199L16.8057 20.4998L27.5811 9.67163C29.3539 7.88987 28.1392 4.87375 25.665 4.78003L25.5469 4.77808H2.58008V0.950928H25.5469L25.8242 0.955811Z"
          fill="#1C7CBA"
        />
        <path
          d="M148.779 7.35498C152.837 7.35498 155.605 9.68278 155.605 14.59V24.1843H152.585V14.9361C152.585 11.6646 151.012 10.0603 148.275 10.0603C145.256 10.0603 143.274 11.9791 143.274 15.5966V24.1843H140.254V14.9361C140.254 11.6646 138.681 10.0603 135.944 10.0603C132.924 10.0603 130.943 11.9791 130.943 15.5966V24.1843H127.923V7.51226H130.817V9.99735C132.012 8.29868 134.057 7.35498 136.573 7.35498C139.121 7.35498 141.261 8.3616 142.361 10.4377C143.62 8.55034 145.948 7.35498 148.779 7.35498Z"
          fill="#1C7CBA"
        />
        <path
          d="M121.12 7.51221H124.14V24.1843H121.277V21.6677C120.05 23.3979 117.974 24.373 115.615 24.373C111.305 24.373 108.443 22.0138 108.443 17.1065V7.51221H111.463V16.7605C111.463 20.032 113.098 21.6677 115.961 21.6677C119.107 21.6677 121.12 19.7174 121.12 16.1314V7.51221Z"
          fill="#1C7CBA"
        />
        <path
          d="M98.6058 24.3731C95.8376 24.3731 93.1009 23.5237 91.7168 22.4228L92.9751 20.032C94.3906 21.0387 96.6555 21.7622 98.826 21.7622C101.626 21.7622 102.79 20.9128 102.79 19.4973C102.79 15.7539 92.2516 18.994 92.2516 12.3566C92.2516 9.36821 94.9254 7.35498 99.2035 7.35498C101.374 7.35498 103.828 7.9212 105.275 8.8649L103.985 11.2556C102.475 10.2805 100.808 9.93443 99.172 9.93443C96.5297 9.93443 95.24 10.9096 95.24 12.2308C95.24 16.1629 105.809 12.9543 105.809 19.4344C105.809 22.4542 103.041 24.3731 98.6058 24.3731Z"
          fill="#1C7CBA"
        />
        <path
          d="M82.2983 7.35498C86.3562 7.35498 89.2187 9.68278 89.2187 14.59V24.1843H86.1989V14.9361C86.1989 11.6646 84.5631 10.0603 81.7006 10.0603C78.492 10.0603 76.4158 11.9791 76.4158 15.5966V24.1843H73.396V7.51226H76.29V10.0288C77.5168 8.33014 79.6559 7.35498 82.2983 7.35498Z"
          fill="#1C7CBA"
        />
        <path
          d="M70.677 15.9427C70.677 16.1943 70.6456 16.5718 70.6141 16.8549H57.0877C57.4652 19.7804 59.8245 21.7307 63.1274 21.7307C65.0777 21.7307 66.7135 21.0701 67.9403 19.7175L69.6075 21.6678C68.0976 23.4294 65.8012 24.3731 63.033 24.3731C57.6539 24.3731 54.0679 20.8185 54.0679 15.8483C54.0679 10.9096 57.6225 7.35498 62.4354 7.35498C67.2482 7.35498 70.677 10.8152 70.677 15.9427ZM62.4354 9.90298C59.5413 9.90298 57.4023 11.8533 57.0877 14.6844H67.783C67.4684 11.8847 65.3608 9.90298 62.4354 9.90298Z"
          fill="#1C7CBA"
        />
        <path
          d="M42.6988 21.6992H52.7964V24.1843H38.8296V22.234L48.6755 9.99729H39.0183V7.51221H52.5447V9.49398L42.6988 21.6992Z"
          fill="#1C7CBA"
        />
      </svg>
    </LogoRoot>
  );
};

export default Logo;
